
//(function (GameResult) {
//    GameResult[GameResult["Tie"] = 0] = "Tie";
//    GameResult[GameResult["BankerWin"] = 1] = "BankerWin";
//    GameResult[GameResult["PlayerWin"] = 2] = "PlayerWin";
//})(GameResult || (GameResult = {}));

//GameResult
// 0 : Tie
// 1 : BankerWin
// 2 : PlayerWin

//(function (PairResult) {
//    PairResult[PairResult["NoPair"] = 0] = "NoPair";
//    PairResult[PairResult["BankerPair"] = 1] = "BankerPair";
//    PairResult[PairResult["PlayerPair"] = 2] = "PlayerPair";
//    PairResult[PairResult["AllPair"] = 3] = "AllPair";
//})(PairResult || (PairResult = {}));

//PairResult
// 0 : NoPair
// 1 : BankerPair
// 2 : PlayerPair
// 3 : AllPair

class RoundResult {
    constructor(order, result, gameResult, pairResult, ties) {
        this.order = order;
        this.result = result;
        this.gameResult = gameResult;
        this.pairResult = pairResult;
        this.ties = ties;
    }
    static from(source) {
        return new RoundResult(source.order, source.result, source.gameResult, source.pairResult, source.ties);
    }
}

export {RoundResult}